import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Platform} from "@angular/cdk/platform";

@Component({
    selector: 'soa-card',
    templateUrl: './soa-card.component.html',
    styleUrls: ['./soa-card.component.scss']
})
export class SoaCardComponent implements OnInit {

    @Input() statement: any;
    @Output() emitActions: EventEmitter<any> = new EventEmitter<any>();

    constructor(public platform: Platform) {
    }

    ngOnInit(): void {
    }

    handleClickActions(actionFrom: any, statement: any) {
        this.emitActions
            .emit({
                actionFrom,
                statement
            });
    }
}
